/* eslint-disable react/require-default-props */
import React from 'react';
import { CardHighlight } from '@amzn/cuminuicomponents';
import SkeletonLoader from '../SkeletonLoader';

export interface SearchListingSkeletonLoaderProps {
  showAvatar?: boolean
}

const SearchListingSkeletonLoader: React.FC<
SearchListingSkeletonLoaderProps
> = ({ showAvatar = true }) => (
  <div className="flex h-[150px] w-full flex-row border border-solid border-kat-seattle">
    <div className="flex flex-auto">
      <CardHighlight cardHighlightColorList={['kat-seattle']} />
      <div className="flex flex-auto flex-row space-x-4 p-4 rtl:space-x-reverse">
        {showAvatar && (
        <div data-testid="skeleton-loader-avatar">
          <SkeletonLoader className="h-[3rem] w-[3rem]" />
        </div>
        )}
        <div className="flex-1 space-y-6 py-1">
          <div className="flex flex-col space-y-3">
            <div className="grid grid-cols-3 gap-4">
              <SkeletonLoader className="col-span-3 h-3" />
              <SkeletonLoader className="col-span-2 h-3" />
              <SkeletonLoader className="col-span-1 h-3" />
              <SkeletonLoader className="col-span-1 h-3" />
              <SkeletonLoader className="col-span-2 h-3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SearchListingSkeletonLoader;
